import React, { useRef, useState } from "react"
import PropTypes from "prop-types"
import { Modal, Grid, Spin } from "antd"
import { ResponsivePage } from "ui/ResponsivePage"
import ClientContactForm from "pagesV2/pro/clients/ClientsContactWindow"
import { useLocation, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { routes } from "router"

const ClientActions = ({ contactType, setSelectedRowKeys }) => {
  const [isVisible, setIsVisible] = useState(true)
  const { useBreakpoint } = Grid
  const screens = useBreakpoint()
  const isMobile = !screens.md
  const title = "Send " + (contactType ? contactType.charAt(0).toUpperCase() + contactType.slice(1) : "")
  const navigate = useNavigate()
  const location = useLocation()
  const { clients, userIds, templates, fromTab, guide } = location.state || {}
  const { loading } = useSelector((store) => store.clients.sendMessage)
  const requestCloseHandlerRef = useRef(null)

  const handleClose = () => {
    if (setSelectedRowKeys) setSelectedRowKeys([])
    setIsVisible(!isVisible)
    const clientId = clients && clients.length > 0 ? clients[0]?.id : null
    if ((fromTab === "email" || fromTab === "text") && clientId) {
      navigate(routes.guideClientPath({ id: clientId }), { state: { activeTab: fromTab } })
    } else {
      navigate(-1)
    }
  }

  const registerRequestClose = (handler) => {
    requestCloseHandlerRef.current = handler
  }

  const handleRequestClose = () => {
    if (typeof requestCloseHandlerRef.current === "function") {
      requestCloseHandlerRef.current()
      return
    }

    handleClose()
  }

  return isMobile ? (
    <ResponsivePage onBackClick={handleRequestClose} pageTitle={title}>
      <ClientContactForm
        handleClose={handleClose}
        type={contactType}
        clients={clients}
        userIds={userIds}
        setSelectedRowKeys={setSelectedRowKeys}
        templates={templates}
        registerRequestClose={registerRequestClose}
      />
    </ResponsivePage>
  ) : (
    <Modal title={title} width={700} open={isVisible} footer={null} onCancel={handleRequestClose}>
      {loading ? (
        <Spin className="text-center w-full" />
      ) : (
        <ClientContactForm
          handleClose={handleClose}
          type={contactType}
          clients={clients}
          userIds={userIds}
          setSelectedRowKeys={setSelectedRowKeys}
          templates={templates}
          guide={guide}
          registerRequestClose={registerRequestClose}
        />
      )}
    </Modal>
  )
}

ClientActions.propTypes = {
  contactType: PropTypes.string.isRequired,
  setSelectedRowKeys: PropTypes.func
}

export default ClientActions
